import { TriCheckbox } from "@nova/component-checkbox"
import * as Icons from "@nova/component-icons"
import classNames from "classnames"
import { LayerStatus } from "../layers/overlays/layerStatus"

const SHIMMER_GRADIENT = "linear-gradient(95deg, #2C2C2D 6.63%, #E2E2E3 42.32%, #2C2C2D 83.76%)"

export const MapFooterLayerCheckboxRow = ({
    title,
    isChecked,
    onClick,
    Icon,
    status,
    disabled,
    onMouseEnter,
    onMouseLeave,
}: {
    title: string
    isChecked: boolean
    onClick: () => void
    Icon?: Icons.IconComponent
    status?: LayerStatus
    disabled?: boolean
    onMouseEnter?: (e: React.MouseEvent<HTMLDivElement>) => void
    onMouseLeave?: () => void
}) => {
    const isLoading = status === "loading"

    return (
        <div
            className={classNames("h-9 flex items-center gap-3 px-4 select-none group", {
                "cursor-pointer": !disabled,
                "cursor-not-allowed": disabled,
            })}
            onClick={disabled ? undefined : onClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <div className="w-6 h-6 p-px flex items-center justify-center shrink-0">
                <TriCheckbox state={isChecked ? "checked" : "unchecked"} isDisabled={disabled} />
            </div>
            <div className="flex items-center gap-2 min-w-0">
                {Icon && (
                    <div className="w-8 h-8 flex items-center justify-center shrink-0">
                        <div
                            className={classNames(
                                "w-8 h-8 p-1 flex items-center justify-center",
                                isLoading && "animate-layer-shimmer-mask text-white"
                            )}
                            style={
                                isLoading
                                    ? {
                                          maskImage: SHIMMER_GRADIENT,
                                          WebkitMaskImage: SHIMMER_GRADIENT,
                                          maskSize: "250% 100%",
                                          WebkitMaskSize: "250% 100%",
                                      }
                                    : undefined
                            }
                        >
                            <Icon
                                className={classNames({
                                    "text-white": isChecked && !isLoading && !disabled,
                                    "text-white-300 group-hover:text-white":
                                        (!isChecked || isLoading) && !disabled,
                                    "text-gray-500": disabled,
                                })}
                            />
                        </div>
                    </div>
                )}
                <span
                    className={classNames(
                        "text-sm truncate",
                        isLoading
                            ? "bg-clip-text text-transparent animate-layer-shimmer-text"
                            : {
                                  "text-white": isChecked && !disabled,
                                  "text-gray-100 group-hover:text-white": !isChecked && !disabled,
                                  "text-gray-500": disabled,
                              }
                    )}
                    style={
                        isLoading
                            ? {
                                  backgroundImage: SHIMMER_GRADIENT,
                                  backgroundSize: "250% 100%",
                                  WebkitTextFillColor: "transparent",
                              }
                            : undefined
                    }
                >
                    {title}
                </span>
            </div>
        </div>
    )
}
